module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Oa6ML2/tc-custom/9781526758569.jpg?1705010292762",
      "alt": "This image is the cover for the book United States Navy Destroyers, Images of War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("United States Navy Destroyers, Images of War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This pictorial history examines the key role played by US Navy destroyers from the turn of the twentieth century through the Cold War and beyond.")]), _c('br'), _c('br'), _vm._v("The first sixteen United States Navy destroyers were ordered in 1898. Prior to America’s entry into the First World War, another sixty-three destroyers were commissioned and, due to the U-boat threat, 267 more were authorized by Congress once hostilities were joined."), _c('br'), _c('br'), _vm._v("Between 1932 and Pearl Harbor ten new classes totaling 169 destroyers came into service. During the Second World War, American shipyards turned out a further 334 vessels. Of the three classes, the 175 Fletcher-class were judged the most successful."), _c('br'), _c('br'), _vm._v("The Cold War years saw the development of seven more classes, while more recent additions include eighty-two of the stealth-shaped Arleigh Burke class. In this comprehensive account, author and military expert Michael Green combines a superb collection of historical images with an authoritative text.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Green\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Maritime\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0